import { render, staticRenderFns } from "./ModalMaster.vue?vue&type=template&id=bf9f84e8"
import script from "./ModalMaster.ts?vue&type=script&lang=ts&external"
export * from "./ModalMaster.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports